<script setup>
import { ref, onMounted, computed } from "vue";

import { useQuizStore } from "@/stores/storeQuiz";
const storeQuiz = useQuizStore();

const isShowListLetters = ref(false);

const showLetters = () => {
	isShowListLetters.value = !isShowListLetters.value;
}

function handleTouchMove(e) {
	const touch = e.touches[0];
	console.log("🚀 ~ handleTouchMove ~ touch:", touch)
	const element = document.elementFromPoint(touch.clientX, touch.clientY);
	if (!element) return;

	const index = Array.from(element.parentNode.children).indexOf(element);
	if (index >= 0) {
		storeQuiz.moveSelect(Math.floor(index / storeQuiz.size), index % storeQuiz.size);
	}
}



onMounted(() => {	

	// @mousedown="storeQuiz.startSelect(Math.floor(index / storeQuiz.size), index % storeQuiz.size)"
								
	// @mouseup="storeQuiz.endSelect"
							
	// @touchstart.prevent="storeQuiz.startSelect(Math.floor(index / storeQuiz.size), index % storeQuiz.size)"
								
	// @touchend.prevent="storeQuiz.endSelect"

});
</script>

<template>
	<div class="quiz-game">
		<div class="quiz-game__overlay" v-if="isShowListLetters"></div>
		<div class="quiz-game__loader" v-if="storeQuiz.isLoaderQuiz">
			<img class="quiz-game__loader-img" width="103" height="103" src="@/assets/img/icons/loader.svg" alt="изображение" />
		</div>
		<div class="container">
			<div class="quiz-game__container">
				<h2 class="quiz-game__title">Найди спрятанные слова, связанные с {{ storeQuiz.currentTopicWords }}</h2>
				<div class="quiz-game__controls">
					<div class="found-words">
						<span class="found-words__title">Найдено слов:</span>
						<div class="found-words__counter">
							<span>{{ storeQuiz.foundWords.length }}</span> 
							<span>/</span>
							<span>{{ storeQuiz.randomWords.length }}</span>
						</div>
					</div>
					<div class="timer">
						<svg width="32" height="32"><use href="#timer"></use></svg>
						<span>{{ storeQuiz.remainingTime.minutes }}:{{ storeQuiz.remainingTime.secundes }}</span>
					</div>
					<div class="questions">
						<button class="questions__btn" @click="showLetters">
							<svg width="48" height="48"><use href="#question"></use></svg>
						</button>
					</div>
				</div>
				

				<div class="quiz-game__pazzle">
					<Transition>
						<div class="quiz-game__letters" v-if="isShowListLetters">
							<button @click="showLetters">
								<svg width='32' height='32'><use href='#x'></use></svg>
							</button>
							<div v-for="word in storeQuiz.randomWords" :key="word">{{ word }}</div>
						</div>
					</Transition>
					<div class="letters">
						<div
							v-for="(cell, index) in storeQuiz.flatGrid"
							:key="index"
							:data-row="Math.floor(index / storeQuiz.size)"
							:data-col="index % storeQuiz.size"
							:class="[
								'letter',
								{
									'--yellow': storeQuiz.highlighted[Math.floor(index / storeQuiz.size)][index % storeQuiz.size],
									'--green': storeQuiz.foundHighlights[Math.floor(index / storeQuiz.size)][index % storeQuiz.size],
									'--blue': storeQuiz.selectedCells.some((c) => c.row === Math.floor(index / storeQuiz.size) && c.col === index % storeQuiz.size),
									'--error': storeQuiz.selectedCells.some(c => c.row === Math.floor(index / storeQuiz.size) && c.col === index % storeQuiz.size && c.error)
								},
							]"
							@click="storeQuiz.handleCellClick(
								Math.floor(index / storeQuiz.size),
								index % storeQuiz.size
							)"
						>
							{{ cell }}
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<style lang="scss" scoped>
@use "@/assets/scss/base/vars";
.quiz-game {
	position: relative;
	padding: 3.4rem 0 10.5rem;
	color: #fff;
	background-image: url('@/assets/img/games/game_line_1.webp'), url('@/assets/img/games/game_line_2.webp');
	background-repeat: no-repeat;
	background-position: 0% 0%, 100% 100%; /* x y*/
	background-size: 16%, 18%;
	@media (max-width: vars.$xx) {
		background-image: none;
		padding: 4.5rem 0 7rem;
	}
}
.quiz-game__overlay{
	top: 0;
	right: 0;
	height: 100%;
	width: 100%;
	z-index: 4;
	transition: 0.5s;
	position: fixed;
	background-color: rgba(41, 41, 41, 0.51);
}
.quiz-game__loader {
	position: fixed;
	inset: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: rgba(255, 255, 255, 0.1);
	backdrop-filter: blur(10.800000190734863px);
	z-index: 2;
}
.quiz-game__loader-img {
	animation: animationLoader 0.7s linear infinite;
}
.quiz-game__container {
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 3.5rem;
	@media (max-width: vars.$x480) {
		gap: 28px;
	}
}
.quiz-game__controls {
	max-width: 64.6rem;
	display: grid;
	grid-template-columns: repeat(3, 18rem);
	align-items: center;
	justify-items: center;
	gap: 5.3rem;
	@media (max-width: vars.$xx) {
		grid-template-columns: 1fr 6.2rem 4.8rem;
		gap: 5rem;
	}
	@media (max-width: vars.$x360) {
		gap: 3rem;

	}
}
.quiz-game__title {
	font-weight: 500;
	font-size: 3.2rem;
	line-height: 120%;
	text-align: center;
	@media (max-width: vars.$x480) {
		font-size: 2.4rem;
	}
}
.found-words {
	display: grid;
	justify-items: center;
	gap: 3px;
	color: #fff;
}
.found-words__title {
	font-weight: 400;
	font-size: 2.4rem;
	line-height: 140%;
	@media (max-width: vars.$x480) {
		font-size: 2rem;
	}
}
.found-words__counter {
	font-weight: 700;
	font-size: 4rem;
	line-height: 140%;
	text-align: center;
	@media (max-width: vars.$x480) {
		font-size: 2.8rem;
	}
	span {
	}
}

.timer {
	width: 100%;
	display: flex;
	align-items: center;
	flex-direction: column;
	svg {
		width: 3.2rem;
		height: 3.2rem;
	}
	span {
		font-weight: 700;
		font-size: 4rem;
		line-height: 140%;
		text-align: center;
		@media (max-width: vars.$x480) {
			font-size: 2.8rem;
		}
	}
}
.questions {
}
.questions__btn {
	width: 4.8rem;
	height: 4.8rem;
	svg {
		width: 100%;
		height: 100%;
		stroke: transparent;
	}
}
.quiz-game__pazzle{
	position: relative;
	@media (max-width: vars.$xx) {
		width: 100%;
	}
}
.quiz-game__letters {
	display: grid;
	min-width: 31rem;
	gap: 2px;
	position: absolute;
	top: 0;
	left: 50%;
	transform: translateX(-50%);
	border-radius: 3.2rem;
	padding: 5.6rem;
	font-weight: 400;
	font-size: 2.4rem;
	line-height: 140%;
	text-transform: lowercase;
	color: var(--text-default-100);
	background: var(--system-fill-light);
	z-index: 5;
	@media (max-width: vars.$x480) {
		padding: 3rem;
		min-width: 28rem;
		font-size: 1.8rem;
	}
	button {
		position: absolute;
		top: 20px;
		right: 20px;
		width: 3.2rem;
		height: 3.2rem;
		svg {
			width: 100%;
			height: 100%;
			fill: transparent;
			stroke: var(--text-accent-1-100);
		}
	}
	
}

.letters {
	border-radius: 4.5rem;
	background-color: #fff;
	display: grid;
	width: 76rem;
	height: 100%;
	grid-template-columns: repeat(13, 1fr);
	grid-template-rows: repeat(13, auto);
	align-items: center;
	justify-items: center;
	padding: 2.8rem;
	aspect-ratio: 1/1;
	@media (max-width: vars.$xx) {
		width: auto;
		border-radius: 2.2rem;
		padding: 1.3rem;
	}
	@media (max-width: vars.$x480) {
	}
	@media (max-width: vars.$x360) {
		border-radius: 1.6rem;
        padding: 0.6rem;

	}
}
.letter {
	cursor: pointer;
	width: 100%;
	height: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	font-weight: 700;
	font-size: 3.2rem;
	line-height: 160%;
	text-transform: uppercase;
	text-align: center;
	color: var(--text-accent-1-100);
	transition: all var(--transition) ease-in;
	@media (max-width: vars.$xx) {
		font-size: 1.6rem;
	}
	@media (max-width: vars.$x360) {
		font-size: 1.5rem;
	}
	&.--yellow {
		background-color: rgba(245, 245, 69, 0.3);
		background-color: transparent;
	}
	&.--green {
		background-color: #00b5ff;
		color: #fff;
	}
	&.--blue {
		background-color:  #0C4CA3;
		color: #fff;
	}
	&.--error {
		background-color: #FF3E3E;
		color: #fff;
	}
}

.v-enter-active,
.v-leave-active {
	transition: 0.5s ease;
}

.v-enter-from,
.v-leave-to {
	opacity: 0;
	transform: translateY(10px);
}
</style>
